import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CanceledOrderEntity } from '../../domain/entities/CanceledOrderEntity'
export class CanceledOrderModel extends CanceledOrderEntity {
  constructor(dataDto) {
    super()
    mapEntityProperties(this, dataDto)
  }
}
